import {
    UpdateAgentId
} from 'one-state-updateuserid/src/model';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Epic User Id Component
 * @param response has the backend
 * Epic User Id  component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result :any = {
        agentiddata:[],
        error:undefined
    }

    const { log } = context;
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
     }
    // TODO:verify backend team check for errors

    if (response.output) {
        let agentinfo:UpdateAgentId[] =[];
        let info = {
            updateuserid: "",
            status:""
        }
        if(response?.output?.params?.panviva_user) {
            info.updateuserid = response?.output?.params?.panviva_user;
            info.status = "200";
        }
        agentinfo.push(info)
        result.agentiddata=agentinfo;
    }
    log.debug(
        "ccw-gadget,Update-epic",
        "Update-epic transformation response ", {
        result
    });
    return result;
}